<template>
  <div style="margin-top: 200px">
    <center>
      {{ title }}
    </center>
  </div>
</template>

<script>
import Vue from 'vue';
import {ACCESS_TOKEN} from '@/store/mutation-types'
import {postAction} from '@/api/manage';
import {Toast} from 'vant';

export default {
  components: {[Toast.name]: Toast},
  data() {
    return {
      code: '',
      title: '授权成功，正在校验数据……',
      url: '/web/api/user/login'
    };
  },
  mounted() {
    this.code = this.$route.query.code;
    this.urls = decodeURI(this.$route.query.urls);
    this.toQs();
  },
  methods: {
    toQs() {
      const that = this;
      postAction(that.url, {wxCode: that.code}).then(res => {
        // alert("res.result.token:"+res.result.token+"--------"+that.urls)
        if (res.result.token) {
          Vue.ls.set(ACCESS_TOKEN, res.result.token)
          if (that.urls.indexOf('register')>0) {
            that.$router.push({name: 'main'});
          } else {
            // alert(that.urls.replace(/&amp;/g,"&"))
            // alert(decodeURIComponent(that.urls.replace(/&amp;/g,"&")))
            window.location.href = decodeURIComponent(that.urls.replace(/&amp;/g,"&"))

          }
        } else {
          // if (that.urls.indexOf('register')) {
          //   window.location.href = that.urls + "&openId=" + res.result.openId
          // } else {
          if (that.urls.indexOf('parentId')>0) {
            window.location.href = that.urls + "&openId=" + res.result.openId
          } else {
            this.$router.push({name: 'account/register', query: {openId: res.result.openId, urls: that.urls}});
            // }
          }
        }
      }).finally(() => {
      })
    }
  }
};
</script>

<style lang="less">
</style>
